import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, tap } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { HttpService } from "../http.service";
import { CancelListResponse, CancelRecord } from "../../../models/admin/orders.model";
import { cancelInput, Coupon, OrderListResponse, SubmitResponse } from "@sgm-frontend/core";
import { CouponInputPayload, CouponInputStatusPayload, CouponListResponse, CouponStatusCountResponse } from "../../../models/admin/coupons.model";


@Injectable({
    providedIn: 'root'
})
export class CouponService extends HttpService<any | cancelInput, CouponListResponse> {
    private couponListSubject = new BehaviorSubject<CouponListResponse | null>(null);
    readonly couponlList$ = this.couponListSubject.asObservable();

    constructor(
        httpClient: HttpClient,
        @Inject('API_URL') apiUrl: string,
        @Inject('API_VERSION') apiVersion: string
    ) {
        super(httpClient, apiUrl, apiVersion, 'coupons');
    }

    getAllCoupons(page = 1, limit = 10): Observable<CouponListResponse | null> {
        return this.getPagedGeneral('coupons', page, limit).pipe(
            tap(response => this.couponListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    getFilteredCoupons(entity: any): Observable<CouponListResponse | null> {
        return this.filterAllActionPaged(entity, '').pipe(
            tap((response) => this.couponListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    deleteCoupon(couponId: string): Observable<SubmitResponse> {
        return this.delete(couponId);
    }
    createCoupon(couponInput: CouponInputPayload): Observable<SubmitResponse> {
        return this.create(couponInput).pipe(catchError((error) => of(error)));
    }
    getCouponsById(couponId: string): Observable<Coupon> {
        return this.getById(couponId).pipe(catchError((error) => of(error)));
    }
    updateCoupon(couponInput: CouponInputPayload,id:string): Observable<SubmitResponse> {
        return this.update(couponInput,id).pipe(catchError((error) => of(error)));
    }
    statusCoupon(couponInput: CouponInputStatusPayload,id:string): Observable<SubmitResponse> {
        return this.update(couponInput,"status/"+id).pipe(catchError((error) => of(error)));
    }
    getStatus(): Observable<CouponStatusCountResponse | null> {
        return this.getAll('status-counts').pipe(catchError((error) => of(error)));
    }

}